export {default as FilterItem} from './FilterItem.connect';
